import { render, staticRenderFns } from "./ArchiveDataTable.vue?vue&type=template&id=6b2f169e&scoped=true&"
import script from "./ArchiveDataTable.vue?vue&type=script&lang=js&"
export * from "./ArchiveDataTable.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveDataTable.vue?vue&type=style&index=0&id=6b2f169e&scoped=true&lang=css&"
import style1 from "./ArchiveDataTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2f169e",
  null
  
)

export default component.exports